var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5251 32.8069L34.0251 32.8069L34.0251 32.3069L34.0251 5.56763C34.0251 3.08235 32.0104 1.06763 29.5251 1.06763L9.15039 1.06763C6.66511 1.06763 4.65039 3.08235 4.65039 5.56763L4.65039 32.3069L4.65039 32.8069L5.15039 32.8069L33.5251 32.8069Z",
    fill: "#B62079",
    stroke: "#F3F3F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46045 21.1701C2.46045 19.4668 3.8413 18.0859 5.54466 18.0859C7.24802 18.0859 8.62887 19.4668 8.62887 21.1701L8.62887 36.7968L6.46045 36.7968C4.25131 36.7968 2.46045 35.0059 2.46045 32.7968L2.46045 21.1701Z",
    fill: "#B62079",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5312 19.7456C31.5312 18.0422 32.9121 16.6614 34.6155 16.6614C36.3188 16.6614 37.6997 18.0422 37.6997 19.7456L37.6997 31.3722C37.6997 33.5814 35.9088 35.3722 33.6997 35.3722L31.5312 35.3722L31.5312 19.7456Z",
    fill: "#B62079",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4595 31.3439L38.4595 35.6301C38.4595 37.8393 36.6686 39.6301 34.4595 39.6301L6.00001 39.6301C3.79087 39.6301 2.00001 37.8393 2.00001 35.6301L2.00001 31.3439L38.4595 31.3439Z",
    fill: "#B62079",
    stroke: "#F3F3F3",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.fbb0113067c74e396295ff1571aaafcf.svg";
export { ForwardRef as ReactComponent };